import { render, staticRenderFns } from "./VoucherIndex.vue?vue&type=template&id=180d1888&scoped=true&"
import script from "./VoucherIndex.vue?vue&type=script&lang=js&"
export * from "./VoucherIndex.vue?vue&type=script&lang=js&"
import style0 from "./VoucherIndex.vue?vue&type=style&index=0&id=180d1888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d1888",
  null
  
)

export default component.exports